import { PRODUCTS_RESPONSE } from "../actions/products";

const productsReducer = (state = [], action) => {
  switch (action.type) {
    case PRODUCTS_RESPONSE:
      return action.products;
    default:
      return state;
  }
};

export default productsReducer;
